import React, { Component, Fragment } from 'react'
import UploadFile from '../../../js/utils/FileUpload'
import MaskedInput from 'react-text-mask'
import Axios from 'axios'
import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik'

class FormCovid19 extends Component {
  constructor(props) {
    super(props)

    // state
    this.state = {
      DEBUG: false,
      isSubmitting: false,
      // form steps and states
      overQuota: false,
      submittedStepOne: false,
      submittedStepTwo: false,
      editingFormTwo: false,
      serverErrors: null,
      eligible: props.eligible,
      // form 1 fields
      CAFNumber: '',
      name: '',
      firstname: '',
      mail: '',
      phone: '',
      numberOfMinors: 0,
      date: [],
      numberOfPersons: 0,
      optin1: false,
      optin2: false,
      optin3: false,
      minorsDates: [],
      // form 2 fields
      address: '',
      addressBuilding: '',
      addressApartmentNumber: '',
      addressComplement: '',
      zipcode: '',
      city: props.city,
      // form 2 backup
      bakAddress: '',
      bakAddressBuilding: '',
      bakAddressApartmentNumber: '',
      bakAddressComplement: '',
      bakZipcode: '',
      bakCity: '',
      // form justification file
      justifUploaded: false,
      justifFile: null,
    }

    // elements outside the component's scope
    this.els = {}

    // refs
    this.$modal = React.createRef();
    this.$closeModal = React.createRef();

    // binding
    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.editFormTwo = this.editFormTwo.bind(this)
    this.cancelFormTwo = this.cancelFormTwo.bind(this)
    this.pushDatas = this.pushDatas.bind(this)
    this.preSubmit = this.preSubmit.bind(this)
  }

  componentDidMount() {
    // component
    this.els.element = this.props.proxy

    // opening the modal / form
    this.els.body = document.querySelector('body')

    this.els.triggerModalOpen = document.querySelector('.js-open-modal--covid')
    if (this.els.triggerModalOpen) {
      this.els.triggerModalOpen.addEventListener('click', this.openModal)
      this.$closeModal.current.addEventListener('click', this.closeModal)
    }
  }

  componentWillMount() {
    //
  }

  componentWillUnmount() {
    this.setState({
      submittedStepOne: false,
      submittedStepTwo: false,
      editingFormTwo: false,
    })
    if (this.els.triggerModalOpen) {
      this.els.triggerModalOpen.removeEventListener('click', this.openModal)
      this.$closeModal.current.removeEventListener('click', this.closeModal)
    }
  }

  openModal(event) {
    this.setState({
      submittedStepOne: false,
      submittedStepTwo: false,
      editingFormTwo: false,
    })
    event.preventDefault()
    this.els.body.classList.add('is-withmodal')
    this.$modal.current.classList.add('is-open')
  }

  closeModal(event) {
    event.preventDefault()
    this.els.body.classList.remove('is-withmodal')
    this.$modal.current.classList.remove('is-open')
  }
  
  editFormTwo(event) {
    event.preventDefault()
    // console.log('on edit state is: ', this.state)
    this.setState({ 
      editingFormTwo: true, 
      justifUploaded: false,
      // store old values in case of cancel
      bakAddress: this.state.address,
      bakAddressBuilding: this.state.addressBuilding,
      bakAddressApartmentNumber: this.state.addressApartmentNumber,
      bakAddressComplement: this.state.addressComplement,
      bakZipcode: this.state.zipcode,
      bakCity: this.state.city,
    })
  }

  cancelFormTwo(event) {
    event.preventDefault()
    this.setState({ 
      editingFormTwo: false, 
      justifUploaded: true,
      // restore old values
      address: this.state.bakAddress,
      addressBuilding:  this.state.bakAddressBuilding,
      addressApartmentNumber: this.state.bakAddressApartmentNumber,
      addressComplement: this.state.bakAddressComplement,
      zipcode: this.state.bakZipcode,
      city: this.state.bakCity,
    })
  }

  preSubmit(formikActions) {
    if (this.state.DEBUG) {
      this.setState({
        submittedStepOne: true,
      })
      return
    }

    const { preSubmitEndpoint } = this.props

    Axios.post(preSubmitEndpoint, {
      caf_id: this.state.CAFNumber,
      zip_code: this.state.zipcode,
      last_name: this.state.name,
      first_name: this.state.firstname,
      email: this.state.mail,
      phone: this.state.phone,
      no_minors: this.state.numberMinors,
      birthdays_minors: this.state.date,
      no_persons: this.state.numberPersons,
      optin: this.state.optin3,
    })
      .then((response) => {
        formikActions.setSubmitting(false)
        if (response.data.status === 422) {
          this.setState({
            eligible: false,
            serverErrors: response.data.errors,
            submittedStepOne: false,
          })
        } else {
          this.setState({
            eligible: true,
            submittedStepOne: true,
            serverErrors: null,
            address: response.data.address,
            addressBuilding: response.data.addressBuilding,
            addressApartmentNumber: response.data.addressApartmentNumber,
            addressComplement: response.data.addressComplement,
            zipcode: response.data.zipcode,
            city: response.data.city,
          })
          // console.log(response.data)
          // console.log('after first form state is: ', this.state)
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  pushDatas(formikActions) {
    this.setState({
      isSubmitting: true,
    })
    if (this.state.DEBUG === false) {
      const { submitEndpoint } = this.props
      Axios.post(submitEndpoint, {
        caf_id: this.state.CAFNumber,
        last_name: this.state.name,
        first_name: this.state.firstname,
        email: this.state.mail,
        phone: this.state.phone,
        no_minors: this.state.numberMinors,
        birthdays_minors: this.state.date,
        no_persons: this.state.numberPersons,
        optin: this.state.optin3,
        address_file: this.state.justifFile,
        address: this.state.address,
        address_building: this.state.addressBuilding,
        address_number: this.state.addressApartmentNumber,
        address_complement: this.state.addressComplement,
        address_apartment_number: this.state.addressApartmentNumber,
        zip_code: this.state.zipcode,
        city: this.state.city,
      }).then((response) => {
        if (response.data.status === 422) {
          this.setState({
            overQuota: false,
            serverErrors: response.data.errors,
            isSubmitting: false,
          })
        } else if (response.data.status === 200) {
          this.setState({
            overQuota: response.data.form.is_over_quota,
            submittedStepOne: true,
            submittedStepTwo: true,
            isSubmitting: false,
          })
        }
      }).catch((error) => {
        console.error(error)
      })
    } else {
      console.log(this.state)
      this.setState({
        submittedStepOne: true,
        submittedStepTwo: true,
      })
    }
  }

  render() {
    return (
      <div
        className="modal"
        ref={this.$modal}
        role="dialog"
        aria-labelledby="dialog-1__Title"
        aria-describedby="dialog-1__Desc"
        id="modal--covid"
      >
        <div className="modal__wrapper">
          <div className={`modal__content ${(this.state.submittedStepOne === true) && 'is-hidden'}`}>
            {/* <!-- @DEVS h2 or any other tag --> */}
            <h2 className="modal__title" id="dialog-1__Title">{this.props.txtTitle}</h2>
            <div
              className="modal__description"
              id="dialog-1__Desc"
              dangerouslySetInnerHTML={{ __html: this.props.txtText }}
            />
            <div className="modal__children">
              {/* <!-- Modal Children --> */}
              <Formik
                initialValues={{
                  ntn__CAFNumber: this.state.CAFNumber,
                  ntn__zipcode: this.state.zipcode,
                  ntn__name: this.state.name,
                  ntn__firstname: this.state.firstname,
                  ntn__mail: this.state.mail,
                  ntn__phone: this.state.phone,
                  ntn__numberMinors: this.state.numberOfMinors,
                  ntn__date: this.state.date,
                  ntn__numberPersons: this.state.numberOfPersons,
                  ntn__optin1: this.state.optin1,
                  ntn__optin2: this.state.optin2,
                  ntn__optin3: this.state.optin3,
                }}
                validate={values => {
                  const errors = {}
                  if (!values.ntn__CAFNumber) {
                    errors.ntn__CAFNumber = this.props.txtErrorRequired
                  }
                  if (!values.ntn__zipcode) {
                    errors.ntn__zipcode = this.props.txtErrorRequired
                  }
                  if (!values.ntn__name) {
                    errors.ntn__name = this.props.txtErrorRequired
                  }
                  if (!values.ntn__firstname) {
                    errors.ntn__firstname = this.props.txtErrorRequired
                  }
                  if (!values.ntn__mail) {
                    errors.ntn__mail = this.props.txtErrorRequired
                  } else if (!/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(values.ntn__mail)) {
                    errors.ntn__mail = this.props.txtErrorMail
                  }
                  if (!values.ntn__numberMinors && values.ntn__numberMinors !== 0) {
                    errors.ntn__numberMinors = this.props.txtErrorRequired
                  }
                  values.ntn__date.map((date, index) => {
                    if (!date) {
                      if (!errors.ntn__date) errors.ntn__date = []
                      errors.ntn__date[index] = this.props.txtErrorRequired
                    }
                  })
                  if (!values.ntn__numberPersons && values.ntn__numberPersons !== 0) {
                    errors.ntn__numberPersons = this.props.txtErrorRequired
                  }
                  if (!values.ntn__optin1) {
                    errors.ntn__optin1 = this.props.txtErrorRequired
                  }
                  if (!values.ntn__optin2) {
                    errors.ntn__optin2 = this.props.txtErrorRequired
                  }
                  return errors
                }}
                onSubmit={(values, actions, isSubmitting, isValidating) => {
                  this.setState({
                    // store new values
                    CAFNumber: values.ntn__CAFNumber,
                    zipcode: values.ntn__zipcode,
                    name: values.ntn__name,
                    firstname: values.ntn__firstname,
                    mail: values.ntn__mail,
                    phone: values.ntn__phone,
                    numberOfMinors: values.ntn__numberMinors,
                    date: values.ntn__date,
                    numberOfPersons: values.ntn__numberPersons,
                    optin1: values.ntn__optin1,
                    optin2: values.ntn__optin2,
                    optin3: values.ntn__optin3,
                  })
                  // push to DB or log stuff
                  this.preSubmit(actions)
                }}
              >
                {({ isSubmitting, errors, values }) => (
                  <Form className="ntn-form">
                    <div className="ntn-form__steptitle">
                      {this.props.txtStep} 1 / 2
                    </div>
                    <fieldset className="ntn-form__fieldset">
                      <div className="ntn-form__fields">
                        <div className="ntn-form__field is-big">
                          <label className="ntn-form__label"
                                 htmlFor="ntn__CAFNumber">{this.props.txtLegendId} *</label>
                          <Field name="ntn__CAFNumber">
                            {({ field }) => (
                              <MaskedInput
                                {...field}
                                id="ntn__CAFNumber"
                                guide={false}
                                mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
                                className="ntn-form__input" />
                            )}
                          </Field>
                          <label className="ntn-form__input-note" htmlFor="ntn__CAFNumber">{this.props.txtNoticeId}</label>
                          <ErrorMessage
                            name="ntn__CAFNumber"
                            render={(msg) => (
                              <label className="ntn-form__input-note is-error" htmlFor="ntn__CAFNumber">{msg}</label>
                            )}
                          />
                        </div>
                        <div className="ntn-form__field is-big">
                          <label className="ntn-form__label"
                                 htmlFor="ntn__zipcode">{this.props.txtLabelFieldZipCode} *</label>
                          <Field name="ntn__zipcode">
                            {({ field }) => (
                                <MaskedInput
                                    {...field}
                                    id="ntn__zipcode"
                                    guide={false}
                                    mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                                    className="ntn-form__input" />
                            )}
                          </Field>
                          <ErrorMessage
                              name="ntn__zipcode"
                              render={(msg) => (
                                  <label className="ntn-form__input-note is-error" htmlFor="ntn__zipcode">{msg}</label>
                              )}
                          />
                        </div>
                      </div>
                    </fieldset>

                    <fieldset className="ntn-form__fieldset">
                      <legend className="ntn-form__legend">
                        {this.props.txtLegendInfos}
                      </legend>
                      <div className="ntn-form__fields">
                        <div className="ntn-form__field">
                          <label className="ntn-form__label" htmlFor="ntn__firstname">{this.props.txtLabelFieldFirstName} *</label>
                          <Field className="ntn-form__input" type="text" name="ntn__firstname" id="ntn__firstname" />
                          <ErrorMessage
                            name="ntn__firstname"
                            render={(msg) => (
                              <label className="ntn-form__input-note is-error" htmlFor="ntn__firstname">{msg}</label>
                            )}
                          />
                        </div>
                        <div className="ntn-form__field">
                          <label className="ntn-form__label" htmlFor="ntn__name">{this.props.txtLabelFieldName} *</label>
                          <Field className="ntn-form__input" type="text" name="ntn__name" id="ntn__name" />
                          <ErrorMessage
                            name="ntn__name"
                            render={(msg) => (
                              <label className="ntn-form__input-note is-error" htmlFor="ntn__name">{msg}</label>
                            )}
                          />
                        </div>
                      </div>
                      <div className="ntn-form__fields">
                        <div className="ntn-form__field">
                          <label className="ntn-form__label" htmlFor="ntn__mail">{this.props.txtLabelFieldMail} *</label>
                          <Field className="ntn-form__input" type="text" name="ntn__mail" id="ntn__mail" />
                          <ErrorMessage
                            name="ntn__mail"
                            render={(msg) => (
                              <label className="ntn-form__input-note is-error" htmlFor="ntn__mail">{msg}</label>
                            )}
                          />
                        </div>
                        <div className="ntn-form__field">
                          <label className="ntn-form__label" htmlFor="ntn__phone">{this.props.txtLabelFieldPhone}</label>
                          <Field className="ntn-form__input" type="text" name="ntn__phone" id="ntn__phone" />
                        </div>
                      </div>
                    </fieldset>
                    <fieldset className="ntn-form__fieldset">
                      <legend className="ntn-form__legend">
                        {this.props.txtLegendHome}
                      </legend>
                      <div className="ntn-form__fields">
                        <div className="ntn-form__field">
                          <label className="ntn-form__label"
                                  htmlFor="ntn__numberPersons">{this.props.txtLabelFieldPersons} *</label>
                          <Field
                            className="ntn-form__input" type="number"
                            name="ntn__numberPersons" id="ntn__numberPersons"
                            min="0" max="99"
                          />
                          <ErrorMessage
                            name="ntn__numberPersons"
                            render={(msg) => (
                              <label className="ntn-form__input-note is-error" htmlFor="ntn__numberPersons">{msg}</label>
                            )}
                          />
                        </div>
                      </div>
                      <div className="ntn-form__instructions">
                        {}
                      </div>
                      <FieldArray
                        render={(arrayHelpers) => (
                          <div className="ntn-form__fieldsest">
                            <div className="ntn-form__fields is-complementary">
                              <div className="ntn-form__field">
                                <label className="ntn-form__label"
                                  htmlFor="ntn__numberMinors">{this.props.txtLabelFieldMinors} *</label>
                                <Field onChange={(event) => {
                                  const v = +event.target.value || 0
                                  values.ntn__numberMinors = v
                                  this.setState({
                                    numberOfMinors: v
                                  })
                                  while (values.ntn__date.length < v) {
                                    values.ntn__date.push('')
                                  }
                                  while (values.ntn__date.length > v) {
                                    values.ntn__date.pop()
                                  }
                                }}
                                  className="ntn-form__input" type="number"
                                  name="ntn__numberMinors" id="ntn__numberMinors"
                                  min="0" max="99"
                                  value={this.state.numberOfMinors}
                                />
                                <ErrorMessage
                                  name="ntn__numberMinors"
                                  render={(msg) => (
                                    <label className="ntn-form__input-note is-error" htmlFor="ntn__numberMinors">{msg}</label>
                                  )}
                                />
                              </div>                      
                              {/* this is a spacer : */}
                              <div className="ntn-form__field" aria-hidden="true" />
                              {this.state.numberOfMinors > 0 && (
                                Array.from({ length: this.state.numberOfMinors }, (v, k) => k + 1).map((el, i) =>
                                  <div key={i} className="ntn-form__field">
                                    <label className="ntn-form__label" htmlFor={`ntn__date-${i}`}>{this.props.txtLabelFieldDate} {i + 1} *</label>
                                    <Field className="ntn-form__input" type="date" id={`ntn__date-${i}`} name={`ntn__date[${i}]`} />
                                    <ErrorMessage
                                      name={`ntn__date[${i}]`}
                                      render={(msg) => (
                                        <label className="ntn-form__input-note is-error" htmlFor={`ntn__date-${i}`}>{msg}</label>
                                      )}
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                        )}>
                      </FieldArray>
                    </fieldset>
                    {this.state.eligible === false && (
                      <div className="ntn-form__warning"
                        dangerouslySetInnerHTML={{ __html: this.props.txtErrorEligibility }}
                      />
                    )}
                    <fieldset className="ntn-form__fieldset">
                      <div className="ntn-form__optins">
                        <div className="ntn-form__optin">
                          <Field type="checkbox" name="ntn__optin1" id="ntn__ntn__optin1" />
                          <label
                            htmlFor="ntn__ntn__optin1"
                            dangerouslySetInnerHTML={{ __html: this.props.txtOptin1 }}
                          />
                          <ErrorMessage
                            name="ntn__optin1"
                            render={(msg) => (
                              <span className="ntn-form__input-note is-error">{msg}</span>
                            )}
                          />
                        </div>
                        <div className="ntn-form__optin">
                          <Field type="checkbox" name="ntn__optin2" id="ntn__optin2" />
                          <label
                            htmlFor="ntn__optin2"
                            dangerouslySetInnerHTML={{ __html: this.props.txtOptin2 }}
                          />
                          <ErrorMessage
                            name="ntn__optin2"
                            render={(msg) => (
                              <span className="ntn-form__input-note is-error">{msg}</span>
                            )}
                          />
                        </div>
                        <div className="ntn-form__optin">
                          <Field type="checkbox" name="ntn__optin3" id="ntn__optin3" />
                          <label
                            htmlFor="ntn__optin3"
                            dangerouslySetInnerHTML={{ __html: this.props.txtOptin3 }}
                          />
                        </div>
                      </div>
                    </fieldset>
                    <div
                      className="ntn-form__notice"
                      dangerouslySetInnerHTML={{ __html: this.props.txtAsterisks }}
                    />
                    {this.state.serverErrors && (
                      <div className="ntn-form__errors">
                        {Object.values(this.state.serverErrors).map((error, index) => (
                          <span key={index}>{error}</span>
                        ))}
                      </div>
                    )}
                    <div className="ntn-form__actions">
                      <button
                        type="submit"
                        className={`ntn-form__submit ${isSubmitting === true && 'is-submitting'}`}
                        disabled={isSubmitting}
                      >
                        <span>{this.props.txtSubmit}</span>
                        <i>
                          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#fff">
                            <g fill="none" fillRule="evenodd">
                              <g transform="translate(1 1)" strokeWidth="2">
                                <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                                <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(308.368 18 18)">
                                  <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                </path>
                              </g>
                            </g>
                          </svg>
                        </i>
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
              {/* <!-- / Modal Children --> */}
            </div>
          </div>
          <div className={`modal__content ${(this.state.submittedStepOne === false || this.state.submittedStepTwo === true) && 'is-hidden'}`}>
            <h2 className="modal__title" id="dialog-1__Title">{this.props.txtTitle}</h2>

            <div className="ntn-form__steptitle">
              {this.props.txtStep} 2 / 2
            </div>
            <Formik
              enableReinitialize={true}
              initialValues={{
                ntn__address: this.state.address,
                ntn__addressBuilding: this.state.addressBuilding,
                ntn__addressApartmentNumber: this.state.addressApartmentNumber,
                ntn__addressComplement: this.state.addressComplement,
                ntn__zipcode: this.state.zipcode,
                ntn__city: this.state.city,
                ntn__justifUploaded: false,
              }}
              validate={values => {
                const errors = {}
                if (!values.ntn__address) {
                  errors.ntn__address = this.props.txtErrorRequired
                }
                if (!values.ntn__city) {
                  errors.ntn__city = this.props.txtErrorRequired
                }
                if (!values.ntn__zipcode) {
                  errors.ntn__zipcode = this.props.txtErrorRequired
                }
                if (!this.state.justifUploaded) {
                  errors.ntn__justifUploaded = this.props.txtErrorMissingFile
                }
                return errors
              }}
              onSubmit={(values, actions, isSubmitting, isValidating) => {
                this.setState({
                  // form steps
                  editingFormTwo: false,
                  // store new values
                  address: values.ntn__address,
                  addressBuilding: values.ntn__addressBuilding,
                  addressApartmentNumber: values.ntn__addressApartmentNumber,
                  addressComplement: values.ntn__addressComplement,
                  zipcode: values.ntn__zipcode,
                  city: values.ntn__city,
                })
                actions.setSubmitting(false)
                if (this.state.DEBUG === false) {
                  // server stuff
                } else {
                  // log stuff
                  this.setState({
                    submittedStepTwo: true
                  })
                  console.log(this.state, values, actions, isSubmitting, isValidating)
                }
              }}
            >
              {({ isSubmitting, errors, values, actions }) => (
                <Form className="ntn-form">
                  {this.state.editingFormTwo === false ? (
                    <Fragment>
                      <fieldset className="ntn-form__fieldset">
                        <legend className="ntn-form__legend">
                          {this.props.txtLegendAdress}
                        </legend>
                        <div className="ntn-form__preview">
                          {this.state.address && (<p>{this.state.address}</p>)}
                          {this.state.addressBuilding && (<p>{this.state.addressBuilding}</p>)}
                          {this.state.addressApartmentNumber && (<p>{this.state.addressApartmentNumber}</p>)}
                          {this.state.addressComplement && (<p>{this.state.addressComplement}</p>)}
                          {(this.state.zipcode || this.state.city) && (<p>{this.state.zipcode} {this.state.city}</p>)}            
                        </div>
                        <div>
                          <button className="ntn-form__modify" type="button" onClick={this.editFormTwo}>{this.props.txtModifyAddress}</button>
                        </div>
                      </fieldset>
                      {this.state.serverErrors && (
                          <div className="ntn-form__errors">
                            {Object.values(this.state.serverErrors).map((error, index) => (
                                <span key={index}>{error}</span>
                            ))}
                          </div>
                      )}
                      <div className="ntn-form__actions">
                        {this.state.isSubmitting}
                        <button 
                          type="button" 
                          className={`ntn-form__submit  ${this.state.isSubmitting === true ? 'is-submitting' : ''}`}
                          disabled={this.state.isSubmitting}
                          onClick={(actions) => this.pushDatas(actions)}>
                            <span>{this.props.txtSendDemand}</span>
                            <i>
                              <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#fff">
                                <g fill="none" fillRule="evenodd">
                                  <g transform="translate(1 1)" strokeWidth="2">
                                    <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                                    <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(308.368 18 18)">
                                      <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                    </path>
                                  </g>
                                </g>
                              </svg>
                            </i>
                          </button>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <fieldset className="ntn-form__fieldset">
                        <legend className="ntn-form__legend">
                          {this.props.txtLegendAddress}
                        </legend>
                        <div className="ntn-form__fields">
                          <div className="ntn-form__field">
                            <label className="ntn-form__label"
                              htmlFor="ntn__address">{this.props.txtLabelFieldAddress} *</label>
                            <Field className="ntn-form__input" type="text" name="ntn__address" id="ntn__address" />
                            <ErrorMessage
                              name="ntn__address"
                              render={(msg) => (
                                <label className="ntn-form__input-note is-error" htmlFor="ntn__address">{msg}</label>
                              )}
                            />
                          </div>
                          <div className="ntn-form__field">
                            <label className="ntn-form__label"
                              htmlFor="ntn__addressBuilding">{this.props.txtLabelFieldAddressBuilding}</label>
                            <Field className="ntn-form__input" type="text" name="ntn__addressBuilding" id="ntn__addressBuilding" />
                            <ErrorMessage
                              name="ntn__addressBuilding"
                              render={(msg) => (
                                <label className="ntn-form__input-note is-error" htmlFor="ntn__addressBuilding">{msg}</label>
                              )}
                            />
                          </div>
                        </div>
                        <div className="ntn-form__fields">
                          <div className="ntn-form__field">
                            <label className="ntn-form__label"
                              htmlFor="ntn__addressApartmentNumber">{this.props.txtLabelFieldAddressApartmentNumber}</label>
                            <Field className="ntn-form__input" type="text" name="ntn__addressApartmentNumber" id="ntn__addressApartmentNumber" />
                            <ErrorMessage
                              name="ntn__addressApartmentNumber"
                              render={(msg) => (
                                <label className="ntn-form__input-note is-error" htmlFor="ntn__addre ssNumber">{msg}</label>
                              )}
                            />
                          </div>
                          <div className="ntn-form__field">
                            <label className="ntn-form__label"
                              htmlFor="ntn__addressComplement">{this.props.txtLabelFieldAddressComplement}</label>
                            <Field className="ntn-form__input" type="text" name="ntn__addressComplement" id="ntn__addressComplement" />
                            <ErrorMessage
                              name="ntn__addressComplement"
                              render={(msg) => (
                                <label className="ntn-form__input-note is-error" htmlFor="ntn__addressComplement">{msg}</label>
                              )}
                            />
                          </div>
                        </div>
                        <div className="ntn-form__fields">
                          <div className="ntn-form__field">
                            <label className="ntn-form__label"
                                   htmlFor="ntn__zipcode">{this.props.txtLabelFieldZipCode} *</label>
                            <Field name="ntn__zipcode">
                              {({ field }) => (
                                  <MaskedInput
                                      {...field}
                                      id="ntn__zipcode"
                                      guide={false}
                                      mask={[/\d/, /\d/, /\d/, /\d/, /\d/]}
                                      className="ntn-form__input" />
                              )}
                            </Field>
                            <ErrorMessage
                                name="ntn__zipcode"
                                render={(msg) => (
                                    <label className="ntn-form__input-note is-error" htmlFor="ntn__zipcode">{msg}</label>
                                )}
                            />
                          </div>
                          <div className="ntn-form__field">
                            <label className="ntn-form__label"
                              htmlFor="ntn__city">{this.props.txtLabelFieldCity} *</label>
                            <Field className="ntn-form__input" type="text" name="ntn__city" id="ntn__city" />
                            <ErrorMessage
                              name="ntn__city"
                              render={(msg) => (
                                <label className="ntn-form__input-note is-error" htmlFor="ntn__city">{msg}</label>
                              )}
                            />
                          </div>
                        </div>
                        <UploadFile
                          onSetFileDelete={() => {
                            this.setState({
                              justifUploaded: false,
                              justifFile: null,
                            })
                          }}
                          onSetFileSuccess={(file, result) => {
                            this.setState({
                              justifUploaded: true,
                              justifFile: `${result.original.path}${result.original.name}`,
                            })
                          }}
                          name="file"
                          config={{ endpoint: this.props.uploadEndpoint }}
                          wording={{
                            label: this.props.txtLabelJustif,
                            notice: this.props.txtNoticeJustif,
                            description: this.props.txtTextJustif,
                            file1: this.props.txtYourFile1,
                            file2: this.props.txtYourFile2,
                            delete: this.props.txtDeleteFile,
                          }}
                        />
                        <ErrorMessage
                          name="ntn__justifUploaded"
                          render={(msg) => (
                            <div className="ntn-form__input-note is-error">{msg}</div>
                          )}
                        />
                      </fieldset>
                      <div className="ntn-form__actions">
                        <button
                          type="submit"
                          className={`ntn-form__submit ${isSubmitting === true ? 'is-submitting' : ''}`}
                          disabled={isSubmitting}
                        >
                          <span>{this.props.txtSaveAddress}</span>
                          <i>
                            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#fff">
                              <g fill="none" fillRule="evenodd">
                                <g transform="translate(1 1)" strokeWidth="2">
                                  <circle strokeOpacity=".5" cx="18" cy="18" r="18" />
                                  <path d="M36 18c0-9.94-8.06-18-18-18" transform="rotate(308.368 18 18)">
                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                  </path>
                                </g>
                              </g>
                            </svg>
                          </i>
                        </button>
                        <button type="button" className="ntn-form__submit is-alternative" onClick={this.cancelFormTwo}>{this.props.txtCancel}</button>
                      </div>
                    </Fragment>
                  )}
                </Form>
              )}
            </Formik>
          </div>
          <div className={`modal__content ${!(this.state.submittedStepOne === true && this.state.submittedStepTwo === true) && 'is-hidden'}`}>
            {/* <!-- h2 or any other tag --> */}
            <h2 className="modal__title modale_success_selector" id="dialog-1__Title">{this.props.txtTitleSuccess}</h2>
            <div
              className="modal__description"
              id="dialog-1__Desc"
              dangerouslySetInnerHTML={{ __html: `${this.props.txtTextSuccess}${this.state.overQuota ? this.props.txtTextSuccessOverQuota : ''}` }}
            />
            <div className="modal__children">
              {/* <!-- Modal Children --> */}
              <div className="modal__actions">
                <button type="button" className="ntn-form__submit" onClick={this.closeModal}>{this.props.txtSubmitSuccess}</button>
              </div>
              {/* <!-- / Modal Children --> */}
            </div>
          </div>
          <div className="modal__close">
            <button type="button" ref={this.$closeModal}>
              <span className="modal__close-label">{this.props.txtClose}</span>
              <i className="icon-close"></i>
            </button>
          </div>
        </div>
        <div className="modal__overlay" aria-hidden="true"></div>
      </div>
    )
  }
}

export default (FormCovid19)


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/form-covid19/FormCovid19.js